import { tooltipClasses, Tooltip, styled } from '@mui/material';

export const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#137DC5',
        padding: '8px',
        color: '#fff',
        '& span': {
            color: '#137DC5',
        },
    },
}));
